<script lang="ts">
  import { EventHandler } from '../../utilities/EventHandler';
  import {
    getPageSelectOptionsArray,
    getDataAttribute,
  } from '../../utilities/DataTableUtilities';

  export let e2eAttributeSuffix: string | undefined;
  export let dataTableId: string | undefined;
  export let totalItems = 100;
  export let currentPage = 1;
  export let itemsPerPage = 10;
  export let itemsPerPageOptions = [5, 10, 15, 20];
  export let rowsPerPageLabel: string;
  export let pageLabel: string;
  export let itemsLabel: string;
  export let showItemsCount: boolean;
  export let loading: boolean;
  export let showAllPages: boolean;

  $: totalPages = Math.ceil(totalItems / itemsPerPage ?? 1);
  $: firstItemOfPageNumber = currentPage * itemsPerPage - (itemsPerPage - 1);
  $: lastItemOfPageNumber =
    firstItemOfPageNumber + itemsPerPage - 1 <= totalItems
      ? firstItemOfPageNumber + itemsPerPage - 1
      : totalItems;
  let eventHandler = new EventHandler();
  $: currentPage;

  function onPageChange(pageNumber: number) {
    eventHandler.dispatch('page-change', {
      currentPage: pageNumber,
      itemsPerPage,
    });
  }
  function onPageSelect() {
    onPageChange(currentPage);
  }
  $: pageSelectOptionsArray = getPageSelectOptionsArray(
    totalPages,
    currentPage,
    showAllPages,
  );
</script>

<div class="mc-datatable__footer">
  <div class="mc-datatable__select">
    <label for="selectRows" class="mc-datatable__select-label">
      {rowsPerPageLabel}
    </label>
    <select
      bind:value={itemsPerPage}
      on:change={() => onPageChange(1)}
      disabled={loading}
      id="selectRows"
      class="mc-select mc-select--s"
      {...getDataAttribute(
        e2eAttributeSuffix,
        `${dataTableId}SelectItemsPerPage`,
      )}
    >
      {#each itemsPerPageOptions as value}
        <option {value} selected={value === itemsPerPage}>{value}</option>
      {/each}
    </select>
  </div>
  {#if showItemsCount && !loading}
    <div class="mc-datatable__count">
      <strong>{firstItemOfPageNumber}-{lastItemOfPageNumber}</strong> /
      <strong>{totalItems} {itemsLabel}</strong>
    </div>
  {/if}
  <div class="mc-datatable__pagination">
    <nav class="mc-pagination" aria-label="pagination">
      <button
        on:click={() => onPageChange(currentPage - 1)}
        class="mc-button mc-button--solid-neutral mc-button--square mc-button--s@from-l"
        aria-label="Previous page"
        disabled={currentPage <= 1 || loading}
        {...getDataAttribute(
          e2eAttributeSuffix,
          `${dataTableId}PreviousPageButton`,
        )}
      >
        <navigation-arrow-arrow--left-32px
          class="mc-button__icon"
          size="100%"
        />
      </button>

      <div class="mc-pagination__field">
        <select
          disabled={loading}
          bind:value={currentPage}
          on:change={onPageSelect}
          class="mc-select mc-pagination__select mc-select--s"
          {...getDataAttribute(e2eAttributeSuffix, `${dataTableId}SelectPage`)}
        >
          {#each pageSelectOptionsArray as page}
            <option value={page}>{pageLabel} {page} / {totalPages}</option>
          {/each}
        </select>
      </div>

      <button
        on:click={() => onPageChange(currentPage + 1)}
        class="mc-button mc-button--solid-neutral mc-button--square mc-button--s@from-l"
        aria-label="Next Page"
        disabled={currentPage === totalPages || loading}
        {...getDataAttribute(
          e2eAttributeSuffix,
          `${dataTableId}NextPageButton`,
        )}
      >
        <navigation-arrow-arrow--right-32px
          class="mc-button__icon"
          size="100%"
        />
      </button>
    </nav>
  </div>
</div>

<!-- svelte-ignore css-unused-selector -->
<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/all-settings';
  @import '@mozaic-ds/styles/components/c.button';
  @import '@mozaic-ds/styles/components/c.select';
  @import '@mozaic-ds/styles/components/c.pagination';
  @import '@mozaic-ds/styles/components/_c.datatable-tools';
  @import '@mozaic-ds/styles/components/_c.datatable-footer';
</style>
